var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Part',{attrs:{"section":"risks_second","chapters":_vm.chapters,"intro":_vm.intro}})
}
var staticRenderFns = []

export { render, staticRenderFns }